export default "__VITE_ASSET__62023aa8__"